<div class="ui modal">
  <div class="ui header">
    Dataset Status
  </div>
  <div class="content">
    <div *ngFor="let dataset of datasets">
      <div *ngIf="dataset.jobs?.length">
        <h3>{{dataset.meta?.display?.name || dataset.name}}</h3>
        <div *ngFor="let job of dataset.jobs" class="ui segment three column grid" [ngClass]="statusColor(job.status)">
          <div class="seven wide column job-name">
            {{job.name}}
          </div>
          <div class="five wide column job-last-success-at">
            <span *ngIf="job.status != 'success' && job.last_success_at !== null">Last succesful update {{relativeDate(job.last_success_at)}}</span>
          </div>
          <div class="four wide column right aligned job-status">
            {{statusName(job.status)}}
            <i class="circle icon" [ngClass]="statusColor(job.status)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <div class="ui cancel button">Done</div>
  </div>
</div>
